import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { IonAlert } from "@ionic/react";

import { setLoading } from "services/loading";
import { getQuizData } from "services/quiz";
import { newUserReset } from "services/users";
// import ChromeCast from "services/chromecast";

import { useToasts } from "components/Toast/toast";
import { logoutWithUpdate } from "services/auth";

interface props {
  availableQuizId: number;
  quizData: Quiz;
  getQuizData: Function;
  setLoading: Function;
  user: any;
  newUserReset: Function;
  logoutWithUpdate: Function;
}

const QuizController: React.FC<props> = ({
  availableQuizId,
  quizData,
  getQuizData,
  setLoading,
  user,
  newUserReset,
  logoutWithUpdate,
}) => {
  const { addToast } = useToasts();
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [userAlertOpen, setUserAlertOpen] = useState<boolean>(false);

  const downloadQuiz = () => {
    setAlertOpen(false);
    setLoading(true, "Loading Quiz Data");
    getQuizData(availableQuizId).then(() => {
      addToast("Quiz data ready");
      setLoading(false);
    });
  };

  useEffect(() => {
    if (availableQuizId) {
      if (
        availableQuizId !== quizData.quizId
        // && availableQuizId > quizData.quizId //was used for preventing old data overwritting new when we had an issue.
      ) {
        setAlertOpen(true);
      }
    } else {
      addToast("Quiz not available");
    }
    //eslint-disable-next-line
  }, [availableQuizId]);

  useEffect(() => {
    if (
      user.lastUser !== null &&
      user.userDetails.customerId !== user.lastUser
    ) {
      setAlertOpen(false);
      setUserAlertOpen(true);
    }
    //eslint-disable-next-line
  }, [user]);

  return (
    <>
      <IonAlert
        isOpen={alertOpen}
        header={`New Quiz Available (${availableQuizId})`}
        subHeader="Would you like to download the new quiz?"
        message="<p>Downloading the new quiz will delete all your quiz data.</p><p>You can not connect to the Chromecast until the new
        quiz is downloaded.</p>"
        buttons={[
          {
            text: "Cancel",
            role: "cancel",
            handler: () => {
              setAlertOpen(false);
            },
          },
          {
            text: "OK",
            role: "confirm",
            handler: () => {
              downloadQuiz();
            },
          },
        ]}
        onDidDismiss={() => setAlertOpen(false)}
      ></IonAlert>
      <IonAlert
        isOpen={userAlertOpen}
        header="Alert"
        subHeader="You are logging in to a different account than your last session"
        message="This will delete all your quiz data."
        buttons={[
          {
            text: "OK",
            role: "confirm",
            handler: () => {
              newUserReset();
              downloadQuiz();
            },
          },
          {
            text: "Cancel",
            role: "cancel",
            handler: () => {
              logoutWithUpdate();
            },
          },
        ]}
        onDidDismiss={() => setAlertOpen(false)}
      ></IonAlert>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  availableQuizId: state.user.userDetails.availableQuizId,
  quizData: state.quiz,
  user: state.user,
});

export default connect(mapStateToProps, {
  getQuizData,
  setLoading,
  newUserReset,
  logoutWithUpdate,
})(QuizController);
